/// <amd-module name="Agile/Boards/Directory/BoardDirectoryConstants" />
export const AreaName = "Boards";
export const LOAD_DIRECTORY = "BoardsRegistration_LoadBoardDirectory";
